import React, { useMemo, useState } from 'react'
import './about-product.scss'
import SpinWithMessage from '../../common/spinners/SpinWithMessage'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'
import Modal from '../../common/modal/Modal'
import CUProductVariant from './CUProductVariant'

const AboutProductVariant = ({ slug }) => {
    const [loading, setLoading] = useState('')
    const [data, setData] = useState({})
    const [modal, setModal] = useState({})

    useMemo(() => {
        setLoading('fetch')
        customerAxios.get(`/production-v0/product-variant/${slug}`)
            .then((response) => {
                setData(response.data || {})
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })

    }, [slug])

    const openEditModel = () => {
        setModal({
            status: true, title: "Edit product", width: '600px',
            content: <CUProductVariant currentData={data} setModal={setModal} setData={setData} isEdit={true} />
        })
    }

    const handleChangeStatus = () => {
        const ask = window.confirm(`Are you ready to ${data?.is_active ? 'Inactive' : "Active"} ?`)

        if (ask) {
            customerAxios.patch(`/production-v0/product-variant/${data?.uuid}/status`, {
                is_active: data?.is_active ? false : true
            }).then(() => {
                setModal({ status: false })
                toast.success(`Product Status Updated!`)

                setData({
                    ...data,
                    is_active: data?.is_active ? false : true
                })

            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    return (
        loading === 'fetch'
            ? <SpinWithMessage message='Loading...' height={'250px'} />
            : <div className="about-product-container">
                <Modal modal={modal} setModal={setModal} />
                <div className="buttons">
                    <button onClick={() => openEditModel()}>Edit Product</button>
                    <button style={{ backgroundColor: data?.is_active ? 'red' : "green" }} onClick={handleChangeStatus}>
                        {data?.is_active ? 'Deactivate' : "Activate"}
                    </button>
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Product</h4>
                    </div>
                    <div className="title-content">
                        <div className="list-div">
                            <div className="one-div">
                                <p>Parent Product Code</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.product_code}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>SKU</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.sku}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Variant Name</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.variant_name}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Description</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.description}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Category</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.product_category}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Wight</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.weight || 0} kg</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Dimensions</p>
                            </div>
                            <div className="two-div">
                                <p>: L: {data?.dimensions?.length || 0} × W: {data?.dimensions?.width || 0} × H: {data?.dimensions?.height || 0} cm</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Warranty Enabled</p>
                            </div>
                            <div className="two-div">
                                <p>: {(data?.services?.has_iw_package || data?.services?.default_warranty?.period)
                                    ? 'Yes'
                                    : "No"
                                }</p>
                            </div>
                        </div>
                        {(data?.services?.has_iw_package || data?.services?.default_warranty?.period) ?
                            <div className="list-div">
                                <div className="one-div">
                                    <p>Warranty</p>
                                </div>
                                <div className="two-div">
                                    <p>: {data?.services?.has_iw_package
                                        ? `${data?.services?.iw_package_id} Package`
                                        : `${data?.services?.default_warranty?.period} Month`
                                    }</p>
                                </div>
                            </div> : ''}
                        <div className="list-div">
                            <div className="one-div">
                                <p>Rent Enabled</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.services?.has_rental ? 'Yes' : 'No'}</p>
                            </div>
                        </div>
                        {data?.services?.has_rental &&
                            <div className="list-div">
                                <div className="one-div">
                                    <p>Rent</p>
                                </div>
                                <div className="two-div">
                                    <p>: ₹{data?.services?.rental_renewal?.renewal_charge || 0} for {data?.services?.rental_renewal?.rental_period} Months</p>
                                </div>
                            </div>}
                        <div className="list-div">
                            <div className="one-div">
                                <p>Purchase Cost</p>
                            </div>
                            <div className="two-div">
                                <p>: ₹{data?.purchase_cost}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Gross Profit</p>
                            </div>
                            <div className="two-div">
                                <p>: ₹{data?.gross_profit?.amount || 0} ({data?.gross_profit?.percentage || 0}%)</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>BC Amount</p>
                            </div>
                            <div className="two-div">
                                <p>: ₹{data?.bc_amount || 0}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Tax (GST)</p>
                            </div>
                            <div className="two-div">
                                <p>: ₹{data?.tax_amount || 0} </p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Selling Rate</p>
                            </div>
                            <div className="two-div">
                                <p>: ₹{data?.selling_rate || 0}</p>
                            </div>
                        </div>

                        <div className="list-div credit-amt">
                            <div className="one-div">
                                <p>Status</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.is_active ? 'ACTIVE' : "INACTIVE"}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Attributes</h4>
                    </div>
                    {data?.attributes?.length > 0
                        ? <>
                            <div className="title-content">
                                {data?.attributes?.map((sp) => {
                                    return <div className="list-div">
                                        <div className="one-div">
                                            <p>{sp?.code}</p>
                                        </div>
                                        <div className="two-div">
                                            <p>: {sp?.value}</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </>
                        : <p>Nil</p>}
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Bundled Components (BC)</h4>
                    </div>
                    {data?.bundled_components?.length > 0
                        ? <>
                            <div className="title-content">
                                {data?.bundled_components?.map((bc) => {
                                    return <div className="list-div">
                                        <div className="one-div">
                                            <p>{bc?.label} {bc?.required ? '(Required)' : ''}</p>
                                        </div>
                                        <div className="two-div">
                                            <p>: ₹{bc?.amount}</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </>
                        : <p>Nil</p>}
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Spares</h4>
                    </div>
                    {data?.spares?.length > 0
                        ? <>
                            <div className="title-content">
                                {data?.spares?.map((sp) => {
                                    return <div className="list-div">
                                        <div className="one-div">
                                            <p>{sp?.spare_id}</p>
                                        </div>
                                        <div className="two-div">
                                            <p>: {sp?.spare_name} - {sp?.spare_category} (Qty : {sp?.qty})</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </>
                        : <p>Nil</p>}
                </div>
            </div>
    )
}

export default AboutProductVariant